<template>
    <div
        class="product-flags d-flex flex-nowrap gap-1"
    >
        <template
            v-for="(flag, index) in modelValue"
            :key="`prod-flag-${flag}`"
        >
            <v-chip
                class="product-flag text-uppercase letter-spacing-6 font-weight-medium"
                variant="flat"
                v-bind="attrs"
                :style="getStyle(flag)"
            >
                <v-icon
                    v-if="flag === 'on_sale'"
                    :icon="mdiSale"
                    size="16"
                    color="white"
                    class="me-1"
                ></v-icon>

                {{ ProductFlagOption[flag] }}
            </v-chip>
        </template>
    </div>
</template>

<script lang="ts" setup>
    import {
        ProductFlagOption,
        type CssStyleObject,
        type ProductFlag
    } from '~/types';
    import { mdiSale } from '@mdi/js';

    defineProps<{
        modelValue: ProductFlag[];
    }>();

    const attrs = useAttrs();

    function getStyle(flag: ProductFlag): CssStyleObject {
        let fgColor = 'rgb(var(--v-theme-surface))';
        let bgColor = 'rgb(var(--v-theme-on-surface))';

        switch (flag) {
            case 'best_seller':
                // Uses default
                break;
            case 'new':
                fgColor = 'rgb(var(--v-theme-on-surface))';
                // TODO: Probably should be a variable
                bgColor = '#F7CD2B';
                break;
            case 'on_sale':
                bgColor = 'rgb(var(--v-theme-success))';
                break;
        }

        return {
            color: fgColor,
            backgroundColor: bgColor
        };
    }
</script>

<style lang="scss"></style>
